import * as actionTypes from '../../actions/actionTypes';

const initialState = {
    lmsApplications: [],
    loadingLmsApplications: false,

    waitingForSignContractResult: false,
    previousSignWasSuccessful: true,

    loadingContract: false
};

////////////////////////////////////////////////////////////////

const loadLmsApplications = (state) => {
    return {
        ...state,
        loadingLmsApplications: true
    }
}

const setLmsApplications = ( state, action ) => {
    let tmp = [...action.lmsApplications]

    return {
        ...state,
        lmsApplications: tmp,
        loadingLmsApplications: false
    }
}

////////////////////////////////////////////////////////////////

const signContract = (state) => {
    return {
        ...state,
        waitingForSignContractResult: true
    }
}

const receiveSignContractResultOnSuccess = (state, action) => {
    let application = action.lmsApplication;
    let applications = state.lmsApplications;

    for (let i = 0; i < applications.length; i++) {
        if (applications[i].lmsApplicationId === application.lmsApplicationId) {
            applications[i] = application;
            break;
        }
    }

    return {
        ...state,
        lmsApplications: applications,
        waitingForSignContractResult: false,
        previousSignWasSuccessful: true
    }
}

const receiveSignContractResultOnError = (state) => {
    return {
        ...state,
        waitingForSignContractResult: false,
        previousSignWasSuccessful: false
    }
}

////////////////////////////////////////////////////////////////

const loadContract = (state) => {
    return {
        ...state,
        loadingContract: true
    }
}

const saveContract = (state) => {
    return {
        ...state,
        loadingContract: false
    }
}

////////////////////////////////////////////////////////////////

const reducer = ( state = initialState, action ) => {
    switch ( action.type ) {
        case actionTypes.LOAD_LMS_APPLICATIONS: return loadLmsApplications( state );
        case actionTypes.SET_LMS_APPLICATIONS: return setLmsApplications( state, action );

        case actionTypes.SIGN_LMS_CONTRACT: return signContract( state );
        case actionTypes.RECEIVE_SIGN_LMS_CONTRACT_RESULT_ON_SUCCESS: return receiveSignContractResultOnSuccess( state, action );
        case actionTypes.RECEIVE_SIGN_LMS_CONTRACT_RESULT_ON_ERROR: return receiveSignContractResultOnError( state );

        case actionTypes.LOAD_LMS_CONTRACT: return loadContract( state );
        case actionTypes.SAVE_LMS_CONTRACT: return saveContract( state );

        default: return state;
    }
};
export default reducer;